
import ScheduleRequest from '~/requests/schedule';
import Sender from '~/api/sender';
import sulu from 'razlet-sulu-sdk/lib/mixins/sulu';
import { getSuluPage } from 'razlet-sulu-sdk/lib/utils/helpers';

export default {
  name: 'schedule-page-departure',
  layout: 'blue',
  mixins: [sulu],
  async asyncData ({ store, route, error, redirect }) {
    const citylist = await Sender.get(`/asb/cities`);
    const result = await getSuluPage({ store, route, error, redirect });

    return {list: citylist.data, result};
  },
  data() {
    return {
      request: new ScheduleRequest(),
      list: [],
      loading: true,
    };
  },
  watch: {
    'request.from.code': {
      handler(value) {
        if (value) this.$router.push({
          name: 'passazhiram-schedule-departure', 
          params: { 
            departure: value, 
          },
        });
      },
    },
  },
  created() {
    this.loading = false;
  },
  mounted() {
    this.$bus.$on('locale-changed', () => {
      this.loading = true;
      window.scrollTo(0, 0);
      this.$nuxt.refresh().then(() => {
        this.fillSulu(this.result);
        this.loading = false;
      });
    });
  },
};
